export default __webpack_public_path__ + "static/media/course availability.78c49a57.png";